import React from 'react';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Page from '../../../components/Page/Page';
import { HomeProvider } from '../../context/homeContext';

import getAllHomePageSettings from './getAllHomePageSettings.graphql'
import { getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import { withQuery } from '../../../hoc/withGraphql';

import s from './PartnerPrivacyPolicy.css';

class PartnerPrivacyPolicy extends React.Component {

  render() {
    const { getAllHomePageSettings: { loading, getAllHomePageSettings }, data: { getEditStaticPage, loading: staticLoading }, currentLocale, containerClass } = this.props
    let homeSettings = {}, dynamicStaticContent, content;
    if (!loading) {
      getAllHomePageSettings && getAllHomePageSettings.homePageData.map((item) => {
        homeSettings[item.name] = item.value
      })
    }

    const pageBanner = getEditStaticPage && getEditStaticPage.result.pageBanner

    dynamicStaticContent = getDynamicTitleByLocale({ dynamicHomePageSettings: getEditStaticPage?.result?.dynamicStaticContent, locale: currentLocale })
    content = dynamicStaticContent[0]?.content || getEditStaticPage.result.content;

    return (
      <div>
        {!loading && !staticLoading &&
          <HomeProvider value={homeSettings}>
            <div className={containerClass}>
              <div className={s.homeBanner} />
              <Page
                html={content}
                pageBanner={pageBanner}
              />
            </div>
          </HomeProvider>
        }
      </div>
    );
  }
}

const mapState = (state) => ({
  currentLocale: state?.intl?.locale
})
const mapDispatch = {};

export default compose(
  withStyles(s),
  withQuery(getAllHomePageSettings, {
    name: 'getAllHomePageSettings',
    options: {
      ssr: false
    }
  }),
  connect(mapState, mapDispatch)
)(PartnerPrivacyPolicy);
